export {default as InfoWrapper} from './InfoWrapper';
export {default as ImageWrapper} from './ImageWrapper';
